<div class="bp-modal">
	<div class="bp-modal-body-section mod-wide p-30 color-black">
		<div class="center-block text-center">
			<h4 class="font-size-24 no-hyphens text-left">{{ titleKey | translate }}</h4>
			<p class="font-size-15 text-left pb-30">{{ data | translate }}</p>
			<div class="mt-30 items-center justify-end">
				<button
					type="button"
					class="btn btn-link mr-10 font-size-15 color-black font-medium"
					(click)="answer(false)">
					{{ buttonNoKey | translate }}
				</button>
				<button type="button" class="btn btn-primary font-size-15 pl-20 pr-20" (click)="answer(true)">
					{{ buttonYesKey | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
